import React from "react";
import { FlagIconCDNProps } from "./types";

const FlagIconCDN: React.FC<FlagIconCDNProps> = ({
  code,
  flagIconClassName = "w-[18px] h-[14px]",
  alt,
}) => {
  // "nil" is the explicit no-country sentinel; an empty/whitespace/missing code means the same thing
  // in practice (callers pass `country.flag || ""` when a country has no flag). Both take the badge:
  // without this guard an empty code built the src "/flags/.svg" and fired a guaranteed 404 plus an
  // onError console.warn on every render.
  const normalizedCode = code?.trim().toLowerCase() ?? "";
  if (!normalizedCode || normalizedCode === "nil") {
    return (
      <div
        className={`px-2 py-1 bg-gray-100 dark:bg-gray-100-dk border-[0.5px] border-gray-75 dark:border-gray-75-dk flex items-center justify-center`}
      >
        {/* -dk, not -dark: the repo's dark tokens all use the -dk suffix, so `heading-text-dark`
            matched no theme token at all and left this text with no dark-mode colour. */}
        <span className="text-xs text-heading-text dark:text-heading-text-dk uppercase">
          {normalizedCode || "nil"}
        </span>
      </div>
    );
  }

  const flagSrc = `/flags/${normalizedCode}.svg`;

  return (
    <img
      src={flagSrc}
      alt={alt || `${normalizedCode} flag`}
      className={`${flagIconClassName} border-[0.5px] border-gray-75 dark:border-gray-75-dk`}
      onError={() => {
        console.warn(`Failed to load flag: ${flagSrc}`);
      }}
    />
  );
};

export default FlagIconCDN;
